import { INIT_MODULE } from './actions';

const initialState = {
    name: null
};

export default function reduser(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case INIT_MODULE:
            return { ...state, name: payload };
      default:
        return state;
    }
}
